import { queryClient } from '@/infra/http'
import {
  LEARNING_PREFERENCES_QUERY_KEY,
  learningPreferencesService,
  LearningPreferencesModel
} from '@/data/services/user/learning-preferences-service'

export type UserLearningPreferencesLoaderDataType = {
  preferences: LearningPreferencesModel
}

/**
 * Carrega as preferências de aprendizado do usuário.
 *
 * Diferente do `loadUserSpace`, aqui a falha NÃO é engolida: nesta página o dado
 * é a própria tela. Renderizar um formulário vazio depois de um GET que falhou
 * faria o usuário salvar por cima do que já existe achando que estava em branco —
 * pior que a tela de erro com botão de recarregar. `fetchQuery` rejeita quando a
 * `queryFn` rejeita, então esse comportamento sobrevive ao cache.
 *
 * `staleTime: 0` porque cada card grava via PATCH e o `useSavePreference`
 * invalida a chave depois de salvar — reentrar na rota tem que refazer o GET, não
 * servir o snapshot pré-save.
 */
export async function loadUserLearningPreferences(): Promise<UserLearningPreferencesLoaderDataType> {
  const preferences = await queryClient.fetchQuery({
    queryKey: [LEARNING_PREFERENCES_QUERY_KEY],
    queryFn: () => learningPreferencesService.fetch(),
    staleTime: 0
  })

  return { preferences }
}
